import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-20 lg:py-32 bg-[#F9F9F9]" data-id="element-363">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-364">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="prose prose-lg md:prose-xl max-w-none text-[#1A1A1A]" data-id="element-365">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-8 leading-tight" data-id="element-366">
            YOU'VE BEEN CARRYING{' '}
            <span className="text-[#C8102E]" data-id="element-367">THIS LONG ENOUGH.</span>
          </h2>

          <p className="font-semibold text-2xl text-gray-800 mb-6" data-id="element-368">
            You know the pile.
          </p>

          <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-369">
            Maybe it's the garage full of furniture you told yourself you'd
            sell. Maybe it's the backyard stacked with old construction debris
            from a project that wrapped up six months ago. Maybe it's a property
            you inherited, a unit your tenant left destroyed, or a business
            space that became a dumping ground when no one was paying attention.
          </p>

          <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-370">
            Whatever it is — it's been there longer than you'd like to admit.
          </p>

          <div className="pl-6 border-l-4 border-[#C8102E] my-10 py-2" data-id="element-371">
            <p className="text-xl md:text-2xl font-medium text-gray-800 italic m-0" data-id="element-372">
              And you're not lazy. You're not irresponsible. You're just busy —
              and this kind of work requires a truck, a team, the physical
              energy, AND the time to make multiple dump runs.
            </p>
          </div>

          <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-373">
            Most people never get all four lined up at once.
          </p>

          <p className="font-bold text-2xl text-[#1A1A1A]" data-id="element-374">
            So the pile stays.
          </p>
        </motion.div>
      </div>
    </section>;
}